module.exports = __webpack_public_path__ + "static/media/speakers6.4d8a75df.jpg";